export default "__VITE_ASSET__DHPeRVl0__"